module.exports = __webpack_public_path__ + "img/fuelPoint.ab905458.png";